import styled from "styled-components";

export const Container = styled.section`
  margin-top: 50px;
  padding-bottom: 100px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Background = styled.div`
  position: absolute;
  width: 120%;
  height: 800px;
  background-color: #3bb77e;
  bottom: 0;
  border-radius: 100% 100% 0 0;
  z-index: -2;
`;

// 공통
export const CommonTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
`;

export const CommonUnderBar = styled.div`
  border-top: 5px solid #3bb77e;
  width: 70px;
  margin-top: 15px;
`;

export const HeadWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`;

// body
export const BodyWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 30px;
  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PriceBox = styled.div`
  width: 100%;
  min-height: 950px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 30px 20px;
  -webkit-box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.2);
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.1);

  .m_under_bar {
    display: none;
  }

  :last-of-type {
    margin-right: 0px;
  }

  .title {
    font-size: 28px;
    line-height: 32px;
    margin-bottom: 30px;
    font-weight: 700;
    color: #3bb77e;
    text-align: center;
  }

  .desc {
    min-height: 80px;
    color: #5d5d5d;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 17px;
    line-height: 24px;
    margin-bottom: 50px;
    text-align: center;
    word-break: keep-all;
    & strong {
      font-weight: 300;
      color: black;
      background-color: #47e99f;
    }
    & span {
      :first-of-type {
        margin-bottom: 20px;
        color: #323232;
        font-weight: 600;
      }
    }
  }
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    max-width: 220px;
    height: 190px;
    & img {
      max-height: 190px;
    }
  }
  .price {
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    & span {
      display: flex;
      align-items: baseline;
      font-size: 24px;
      > h3 {
        font-size: 45px;
      }
    }
  }
  .check {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    word-break: keep-all;
    font-size: 20px;
    margin-bottom: 30px;
    & li {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      & span {
        display: flex;
        align-items: center;
        margin-right: 10px;
        white-space: nowrap;
        :first-of-type {
          display: flex;
          align-items: center;
          justify-content: center;
          justify-content: flex-end;
        }
        :last-of-type {
          width: 70%;
        }
      }
      .active {
        color: #373737 !important;
        font-weight: 600;
      }
      & img {
        max-width: 24px;
        max-height: 24px;
      }
    }
  }
  .comment {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    line-height: 24px;
    color: #3bb77e;
    border-top: 1px solid #5d5d5d;
    padding: 10px;
    margin-bottom: 30px;
  }
  .confirm {
    width: 100%;
    text-align: center;
    display: flex;

    & span {
      cursor: pointer;
      margin-right: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .on {
        display: none;
      }

      .off {
        display: block;
      }

      .tip {
        display: none;
        text-align: center;
        position: absolute;
        background-color: #f9f9f9;
        border: 1px solid #bcbcbc;
        border-radius: 5px;
        box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
        width: 200%;
        white-space: nowrap;
        padding: 2px 5px;
        top: -80%;
        left: -50%;
        margin: 0;
      }

      :hover {
        .tip {
          display: block;
        }
        .on {
          display: block;
        }
        .off {
          display: none;
        }
      }
    }

    & button {
      width: 80%;
      font-size: 23px;
      padding: 5px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .image_price_check {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .desc_image_m {
    display: none;
  }
  .md_m {
    display: none;
  }
  .price_m {
    display: none;
  }

  @media screen and (max-width: 1199px) {
    .title {
      font-size: 24px;
    }
    .desc {
      font-size: 14px;
    }
    .price {
      & span {
        font-size: 20px;
        h3 {
          font-size: 40px;
        }
      }
      p {
        font-size: 14px;
      }
    }
    .check {
      & span {
        font-size: 18px;
      }
      & img {
        max-width: 22px;
        max-height: 22px;
      }
    }
    .comment {
      font-size: 18px;
    }
    .confirm {
      & button {
        font-size: 20px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    height: fit-content;
    min-height: auto;
    padding: 30px 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    .title_desc {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .title {
      font-size: 24px;
    }
    .desc {
      font-size: 14px;
      margin-bottom: 10px;
      min-height: auto;
    }

    .image_price_check {
      flex-direction: row;
      align-items: center;
      > div {
        margin-right: 20px;
      }
    }

    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      & img {
        max-width: 150px;
      }
    }

    .price {
      margin-bottom: 10px;
      & span {
        font-size: 18px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        h3 {
          font-size: 36px;
        }
      }
      p {
        font-size: 12px;
      }
    }
    .check {
      margin-bottom: 10px;
      & span {
        font-size: 16px;
      }
      & img {
        max-width: 20px;
        max-height: 20px;
      }
    }
    .comment {
      font-size: 16px;
      line-height: 1.2;
      text-align: center;
      word-break: keep-all;
    }
    .confirm {
      & button {
        font-size: 18px;
      }
    }
  }
  @media screen and (max-width: 575px) {
    padding: 20px 10px;
    display: flex;
    flex-direction: column;

    .title_desc {
      display: flex;
    }
    .desc_image_price_p {
      display: none;
    }
    .desc_image_m {
      display: flex;
      flex-direction: column;

      .desc {
        margin-bottom: 30px;
        font-size: 12px;
        max-width: 170px;
      }
    }
    .md_m {
      display: flex;
      width: 100%;
      justify-content: center;
      .check_comment_m {
        .check {
          margin: 0 0 0 10px;
          & li {
            margin-bottom: 13px;
            & span {
              & img {
                min-width: 16px;
                max-height: 16px;
              }
              font-size: 12px;
            }
            .active {
              color: #373737 !important;
            }
          }
        }
        .comment {
          border: none;
          font-size: 12px;
        }
      }
    }
    .image_price_check {
      display: none;
    }

    .m_under_bar {
      display: block;
      border-top: 1px solid #5d5d5d;
      width: 90%;
    }

    .price_m {
      display: flex;
      flex-direction: column;
      width: 50%;
      .price {
        margin-top: 10px;
        & span {
          font-size: 12px;
        }
        & h3 {
          font-size: 26px;
        }
        & p {
          font-size: 12px;
        }
      }
      .confirm {
        padding: 0;
      }
      & button {
        font-size: 14px;
      }
    }
  }
`;
